<template>
  <div
    v-if="getAllFamilyResult && getAllFamilyResult.length > 0"
    class="row newTable comfirm"
  >
    <div class="col-md-12">
      <h5>此家戶原本的成員</h5>
      <table id="customer-list" class="table datatable insurance-green">
        <thead>
          <tr>
            <th :width="Math.floor(718 * 0.17) + 'px'">
              身分
              <span class="waring-block d-inline-block ml-1"> </span>
            </th>
            <th :width="Math.floor(718 * 0.35) + 'px'">
              姓名
              <span class="waring-block d-inline-block ml-1"> </span>
            </th>
            <th :width="Math.floor(718 * 0.35) + 'px'">
              性別
              <span class="waring-block d-inline-block ml-1"> </span>
            </th>
            <th :width="Math.floor(718 * 0.35) + 'px'">
              生日
              <span class="waring-block d-inline-block ml-1"> </span>
            </th>
            <th :width="Math.floor(718 * 0.17) + 'px'">年齡</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in getAllFamilyResult"
            :key="`familiy-item-${i}`"
          >
            <td style="width: 180px">{{ changeFamilyRL(item.familyrl) }}</td>
            <td><truncate-tool :content="item.name"></truncate-tool></td>
            <td>{{ item.sex === "1" ? "男" : "女" }}</td>
            <td>{{ formatDate(item.birthday) }}</td>
            <td>{{ item.age }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <popover name="namepop" :width="300">
      {{ popName }}
    </popover>
  </div>
  <div v-else>
    <div class="text-center d-flex justify-content-center mt-5" colspan="6">
      <div :class="{ 'loadingArea mt-4 section-loading': isLoading }"></div>
      <h3 class="mb-3 pre-formatted">{{ this.remoteDataMessage }}</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAllFamily } from "@/service";
import { commonMixin } from "@/mixins/common";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool";
export default {
  name: "bkmvAddFamily",
  mixins: [commonMixin],
  components: { TruncateTool },
  data() {
    return {
      getAllFamilyResult: [],
      popName: "",
      remoteDataMessage: "資料讀取中，請稍候...",
      isLoading: false,
      //是否為保代用頁面
      isFromBank: true,
    };
  },
  props: {
    originalFamily: {
      type: String,
      default: "",
    },
  },
  methods: {
    formatDate(preDate) {
      if (preDate) {
        let dd = window
          .moment(preDate)
          .format("YYYY-MM-DD")
          .split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    changeFamilyRL(familyRl, isRef) {
      if (isRef === "Y") {
        if (familyRl === "戶長") {
          return 0;
        } else if (familyRl === "配偶") {
          return 1;
        } else if (familyRl === "子女") {
          return 2;
        } else if (familyRl === "父母") {
          return 3;
        } else if (familyRl === "其他") {
          return 4;
        } else if (familyRl === "孫子女") {
          return 5;
        }
      } else {
        if (familyRl === 0) {
          return "戶長";
        } else if (familyRl === 1) {
          return "配偶";
        } else if (familyRl === 2) {
          return "子女";
        } else if (familyRl === 3) {
          return "父母";
        } else if (familyRl === 4) {
          return "其他";
        } else if (familyRl === 5) {
          return "孫子女";
        }
      }
    },
  },
  mounted() {
    this.isLoading = true;

    if (this.$route.params.AllFamilyResult) {
      this.getAllFamilyResult = this.$route.params.AllFamilyResult;
      this.getAllFamilyResult.some((item) => {
        if (item.familyrl == 1) {
          this.$emit("sendFamilyResult", true);
          return true;
        }
      });
      this.remoteDataMessage = "查無資料，請確認您輸入之資料是否正確";
      this.isLoading = false;
      this.registerHanlink(); // for 難字更新
    } else {
      getAllFamily(
        this.$store.state.userInfo.id,
        this.originalFamily,
        this.isFromBank
      ).then((result) => {
        if (result.header && result.data) {
          this.getAllFamilyResult = result.data;
        } else {
          this.getAllFamilyResult = [];
        }
        this.getAllFamilyResult.some((item) => {
          if (item.familyrl == 1) {
            this.$emit("sendFamilyResult", true);
            return true;
          }
        });
        this.remoteDataMessage = "查無資料，請確認您輸入之資料是否正確";
        this.isLoading = false;
        this.registerHanlink(); // for 難字更新
      });
    }
  },
};
</script>

<style scoped>
.loadingArea {
  width: 30px;
  height: 30px;
}
</style>
